export default {
  COMPLETED: 1,
  NOT_STARTED: 0,
  CONTINUAL: -1,
};
